/**
 * Created by claudio iozzia on 07/04/2017.
 */

import {Ic} from "./common";
import {Utils} from "../common/utils";

/*
 * [].sort(compare(a, b))
 * return value
 *   0 == they are equal in sort
 *   <0 == a comes before b (index of a is lower than index of b)
 *   >0 == b comes before a (index of b is lower than index of a)
 */
export type IComparatorFn<T> = (a: T, b: T, c?: T, d?: T) => number;

export function multiSorter<T>(sorters: IComparatorFn<T>[]): IComparatorFn<T> {
  return (s, t, x, y) => sorters.reduce((acc, f) => acc === 0 ? f(s, t, x, y) : acc, 0);
}

export const comparator_log = (str: string): IComparatorFn<Ic> => {
  return (a: Ic, b: Ic): number => {
    // if (a.topology.toLowerCase() == "pfc_boost" && b.topology.toLowerCase() == "pfc_boost")
//      console.log ("Comparator log " + str +" ", a, b);
    return 0;
  };
};

export const comparator_Severity: IComparatorFn<Ic> = (a: Ic, b: Ic): number => {
  // order severity ascent
  const severityA: number = Utils.getFieldValue(a, "warning.severity", 0);
  const severityB: number = Utils.getFieldValue(b, "warning.severity", 0);
  return severityA - severityB;
};

export const comparator_AppName: IComparatorFn<Ic> = (a: Ic, b: Ic): number => {
  // order appname ascending
  const appNameA: string = Utils.getFieldValue(a, "app_name", "");
  const appNameB: string = Utils.getFieldValue(b, "app_name", "");
  const valA = appNameA.endsWith('_html') ? 1 : 0;
  const valB = appNameB.endsWith('_html') ? 1 : 0;
  return valB - valA;
};

export const comparator_ReleaseDate: IComparatorFn<Ic> = (a: Ic, b: Ic, direction: any = -1, sortName?: any): number => {
  // Order Release Date
  // default direction: descent (-1)
  const compResult = a.releaseDate ? a.releaseDate.localeCompare(b.releaseDate) : (b.releaseDate ? 1 : 0);
  return (sortName && sortName === 'Default') ? direction * compResult : compResult;
};

export const comparator_Priority: IComparatorFn<Ic> = (a: Ic, b: Ic): number => {
  // Order Priority descent
  const priorityA: number = Utils.getFieldValue(a, "designData.priority", Number.MIN_VALUE);
  const priorityB: number = Utils.getFieldValue(b, "designData.priority", Number.MIN_VALUE);
  return priorityB - priorityA;
};

export const comparator_Topology: IComparatorFn<Ic> = (a: Ic, b: Ic, direction: any = 1, sortName?: any): number => {
  // Order Topology
  // default direction: ascending (1)
  const compResult = a.topology.localeCompare(b.topology);
  return (sortName && sortName === 'Topology') ? direction * compResult : compResult;
};

export const comparator_Package: IComparatorFn<Ic> = (a: Ic, b: Ic, direction: any = 1, sortName?: any): number => {
  // Order Package
  // default direction: ascending (1)
  const compResult = a.packageName.localeCompare(b.packageName);
  return (sortName && sortName === 'Package') ? direction * compResult : compResult;
};

export const comparator_CPN: IComparatorFn<Ic> = (a: Ic, b: Ic, direction: any = 1, sortName?: any): number => {
  // Order CPN
  // default direction: ascending (1)
  const compResult = a.CPN.localeCompare(b.CPN);
  return (sortName && sortName === 'Part Number') ? direction * compResult : compResult;
};

export const comparator_Efficiency: IComparatorFn<Ic> = (a: Ic, b: Ic): number => {
  // order efficiency descending
  return (b.efficiency - a.efficiency);
};

export const comparator_IdLim: IComparatorFn<Ic> = (a: Ic, b: Ic, direction: any = 1, sortName?: any): number => {
  // Order IdLim
  // default direction: ascending (1)
  const IdLimA: number = Utils.getFieldValue(a, "designData.ILIM_min", Utils.getFieldValue(a, "designData.IdLim", Number.MAX_VALUE));
  const IdLimB: number = Utils.getFieldValue(b, "designData.ILIM_min", Utils.getFieldValue(b, "designData.IdLim", Number.MAX_VALUE));
  const compResult = IdLimA - IdLimB;
  return (sortName && sortName === 'ID lim') ? direction * compResult : compResult;
};

export const comparator_IOUT_max: IComparatorFn<Ic> = (a: Ic, b: Ic, direction: any = 1, sortName?: any): number => {
  // order IOUT_max
  // default direction: ascending (1)
  const IoutMaxA: number = Utils.getFieldValue(a, "iout_max", Number.MAX_VALUE);
  const IoutMaxB: number = Utils.getFieldValue(b, "iout_max", Number.MAX_VALUE);
  const compResult = IoutMaxA - IoutMaxB;
  return (sortName && sortName === 'Iout max') ? direction * compResult : compResult;
};

export const comparator_VinDelta: IComparatorFn<Ic> = (a: Ic, b: Ic, direction: any = 1, sortName?: any): number => {
  // order VinDelta
  // default direction: ascending (1)
  const a_vmin_delta = Utils.getFieldValue(a, "vin_max", Number.MAX_VALUE) - Utils.getFieldValue(a, "vin_min", Number.MAX_VALUE);
  const b_vmin_delta = Utils.getFieldValue(b, "vin_max", Number.MAX_VALUE) - Utils.getFieldValue(b, "vin_min", Number.MAX_VALUE);
  const compResult = a_vmin_delta - b_vmin_delta;
  return (sortName && sortName === 'Vin delta') ? direction * compResult : compResult;
};

export const comparator_VinMax: IComparatorFn<Ic> = (a: Ic, b: Ic, direction: any = 1, sortName?: any): number => {
  // order Vin MAX
  // default direction: ascending (1)
  const compResult =  a.vin_max - b.vin_max;
  return (sortName && sortName === 'Vin max') ? direction * compResult : compResult;
};

export const comparator_VinMin: IComparatorFn<Ic> = (a: Ic, b: Ic, direction: any = 1, sortName?: any): number => {
  // order Vin min
  // default direction: ascending (1)
  const compResult =  a.vin_min - b.vin_min;
  return (sortName && sortName === 'Vin min') ? direction * compResult : compResult;
};

export const comparator_PN_PKG: IComparatorFn<Ic> = (a: Ic, b: Ic): number => {
  // order PN + Package ascending
  const aS: string = (a.CPN + a.packageName).toLowerCase();
  const bS: string = (b.CPN + b.packageName).toLowerCase();
  return aS.localeCompare(bS);
};


export interface IComparator {
  compare: (specEdited: boolean) => IComparatorFn<Ic>;
  compareField: (field: string, specEdited: boolean) => IComparatorFn<Ic>;
}

export class Comparator implements IComparator {
  protected get compareBaseFns() {
    return {
      'Part Number': comparator_CPN,
      'Topology': comparator_Topology,
      'Package': comparator_Package,
      'Iout max': comparator_IOUT_max,
      'Vin delta': comparator_VinDelta,
      'Vin max': comparator_VinMax,
      'Vin min': comparator_VinMin,
      'ID lim': comparator_IdLim
      // 'Efficiency': multiSorter([comparator_Severity,
      //                                   comparator_AppName,
      //                                   comparator_Efficiency]),
    };
  }

  protected get compareDefaultFnsList(): IComparatorFn<Ic>[] {
    return [];
  }

  protected get compareDefaultFnsListWhenSpecEdited(): IComparatorFn<Ic>[] {
    return [];
  }

  compare = (specEdited: boolean) => !specEdited ? multiSorter(this.compareDefaultFnsList) : multiSorter(this.compareDefaultFnsListWhenSpecEdited);

  compareField(field: string, specEdited: boolean = null): IComparatorFn<Ic> {
    return Utils.getFieldValue(this.compareBaseFns, field, this.compare(specEdited));
  }

}
